import { Component, Output, EventEmitter, OnInit, OnDestroy, OnChanges, AfterViewInit, SimpleChanges } from '@angular/core';
import { sortBy } from 'lodash';
import { BehaviorSubject, Subscription, interval, mergeMap, timer } from 'rxjs';
import { SITESLIST_REFRESH_INTERVAL_SECONDS } from '../models/app-constants';
import { BeachSite } from '../models/BeachSite';
import { SitesService } from '../services/sites.service';
import { UpdateSitePollForecast } from '../models/Site';



@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements OnInit, OnDestroy, OnChanges {
	
	allSites$ = new BehaviorSubject<BeachSite[]>([]);	
	private sitesSub : Subscription;
	private intervalSub : Subscription;	

	public nswLogo = new URL(
		'assets/images/home/nsw-government-logo.svg',
		import.meta.url
	).toString();


	constructor(private sitesService : SitesService)
	{

	}

	ngOnInit(): void {
		//this.fetchSites();
	}
	
	ngAfterViewInit() : void {
		this.fetchSites();
	}

	ngOnChanges(changes : SimpleChanges) {

	}
	
	ngOnDestroy(): void {	
		this.intervalSub && this.intervalSub.unsubscribe();	
	}

	private fetchSites = () => {		
		this.intervalSub = timer(0, SITESLIST_REFRESH_INTERVAL_SECONDS).pipe(mergeMap(() => {
			return this.sitesService.getSites();
		})).subscribe({
			next : (data) => {
							
				this.createBeachSites(data);
				console.log(`[ Received sites : ${new Date().toString()} ]`);	
			},
			error : (ex) => {
				console.log(`[ Exception fetching beach sites from server : ${ex.message} ]`);
			},
			complete : () => {

			}
		});	
	}

	private createBeachSites = (data : any) => {
		let sites = [];
		//if(data && Array.isArray(data.features))
		if(Array.isArray(data))
		{	
			sites = sortBy(data, "SiteName");
		}			
		
		/* Approach 2 : observable */	
		//this.beachSites$.next(sites);
		this.allSites$.next([...sites]);
		/* Approach 3 : Use a service to communicate between components */	
		//this.beachsitesListService.setBeachSitesList(sites);
	}

	get sites() : BeachSite[] {
		const list = this.allSites$.getValue();		
		return list;
	}

	/*	
		All the beach sites are passed down from the home component to maps section componentand search component.
		Pollution forecasts are run on the server everyday at 6 am and 12:30 am.
		In the home component, sites are fetched every 5 minutes and redrawn on the map.
		However there may occur a time when the pollution forecast returned by a site's pop-up info is different from that site's
		pollution forecast when it was draw on the map during the previous refresh. 
		So we have inform the parent component i.e home to update the site or fetch all the sites again/
		redrawSites is the event that is emitted to update the a site's pollution forecast in the parent.
	*/

	public onUpdateSitePollutionForecast = (event : UpdateSitePollForecast) => {
		if(!event?.siteId || !event?.pollutionForecast)
		{
			return;
		}		
		const allBeachSites = this.allSites$.getValue();
		const beachSite = allBeachSites.find((a : BeachSite) => a.Identifier === event.siteId);
		if(beachSite)
		{
			beachSite.PollutionForecast = event.pollutionForecast;
			this.allSites$.next(allBeachSites.map((a : BeachSite) => {
				return new BeachSite(a.Identifier, a.SiteName, a.PollutionForecast, a.LatestResultStarRating,
					a.Council, a.SubRegion, a.ParentRegion, a.PartnerGroup, a.Lat, a.Lng, a.SiteType);
			}));												
		}		
	}
}
